import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import DonationsShowContainer from 'hb-react/shared/apps/Donations/containers/DonationsShowContainer';
import DonationsSuccessContainer from 'hb-react/shared/apps/Donations/containers/DonationsSuccessContainer';

import DonationsIndexContainer from './containers/DonationsIndexContainer';

const DonationsApp = (props) => (
  <ReactRouterRoutes>
    <Route path=":campaignId">
      <Route index element={<DonationsShowContainer />} />
      <Route path="success" element={<DonationsSuccessContainer />} />
    </Route>
    <Route index element={<DonationsIndexContainer {...props} />} />
  </ReactRouterRoutes>
);

export default DonationsApp;
